import React from 'react';

const Calendar2SVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M1 7.82074C1 5.11318 1 3.75941 1.84113 2.91828C2.68226 2.07715 4.03603 2.07715 6.74359 2.07715H9.61538C12.3229 2.07715 13.6767 2.07715 14.5178 2.91828C15.359 3.75941 15.359 5.11318 15.359 7.82074V9.25664C15.359 11.9642 15.359 13.318 14.5178 14.1591C13.6767 15.0002 12.3229 15.0002 9.61538 15.0002H6.74359C4.03603 15.0002 2.68226 15.0002 1.84113 14.1591C1 13.318 1 11.9642 1 9.25664V7.82074Z'
        stroke='black'
      />
      <path d='M4.58984 2.07741V1.00049' stroke='black' strokeLinecap='round' />
      <path d='M11.7695 2.07741V1.00049' stroke='black' strokeLinecap='round' />
      <path d='M1.35938 5.66724H15.0004' stroke='black' strokeLinecap='round' />
    </svg>
  );
};

export default Calendar2SVG;
